<ng-template #templateRef>
    <form #editorForm="ngForm" name="editRelation" id="articleEditor" (ngSubmit)="save()">
        <h2 mat-dialog-title>Enter your data</h2>
        <mat-dialog-content>

            <table class="mat-mdc-table">
                <tr>
                    <th>Discriminator</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th class="text-right" style="width: 30px;"></th>
                </tr>
                <ng-container *ngFor="let line of Copy;" [ngModelGroup]="line.randomNumber" #ngGroup="ngModelGroup">
                    <tr>
                        <td>{{line.Type?.Discriminator}}</td>
                        <td>
                            <app-dropdown-selector [where]="{Model: 'ActivationEntry'}" [(ngModel)]="line.Type" name="subtype" required></app-dropdown-selector>
                        </td>
                        <td>
                            <mat-form-field><mat-label>Amount</mat-label><input matInput type="number" [(ngModel)]="line.Amount" name="amount" min="0" required></mat-form-field>
                        </td>
                        <td class="text-right" style="width: 30px;">
                            <button type="button" mat-icon-button appConfirmDialog (confirm)="removeLine(line)">
                                <mat-icon>
                                    delete
                                </mat-icon>
                            </button>
                        </td>
                    </tr>
                </ng-container>
                <tr>
                    <td></td>
                    <td></td>
                    <td class="text-right" style="width: 30px;">
                        <button type="button" mat-icon-button (click)="newLine()">
                            <mat-icon>
                                add
                            </mat-icon>
                        </button>
                    </td>

                </tr>
            </table>

        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="fill-remaining-space"></div>
            <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
            <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
        </mat-dialog-actions>
    </form>
</ng-template>
